/** Vista KPI (VISTE di @qa/shared) del percorso corrente: la usa il beacon d'uso (QA26-F5) e l'aiuto in linea. */
import type { Vista } from "@qa/shared";

export function vistaDi(path: string): Vista | null {
  if (path === "/") return "home";
  if (path === "/redflag") return "redflag";
  if (path === "/redflag/segnalazioni" || path === "/redflag/segnalazioni/nuova") return "segnalazioni";
  if (path.startsWith("/redflag/segnalazioni/")) return "segnalazione";
  // «Le mie azioni»: la lista delle viste è chiusa (contratto KPI), conta come elenco delle segnalazioni
  if (path === "/redflag/azioni") return "segnalazioni";
  if (path.startsWith("/redflag/nc/")) return "nc";
  if (path.startsWith("/redflag/report")) return "report";
  if (path.startsWith("/claim")) return "claim";
  if (path.startsWith("/fornitori")) return "fornitore";
  if (path.startsWith("/proposte")) return "proposte";
  if (path.startsWith("/admin")) return "admin";
  return null;
}
